import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => { setF({ ...f, [k]: e.target.value }); setErr(""); };
  const close = () => { setOpen(false); setF({ current: "", next: "", confirm: "" }); setErr(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8 || !/[A-Za-z]/.test(f.next) || !/\d/.test(f.next)) return setErr("La nuova password deve avere almeno 8 caratteri, con lettere e numeri");
    if (f.next !== f.confirm) return setErr("La conferma non corrisponde alla nuova password");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password aggiornata correttamente");
      close();
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setBusy(false); }
  };

  const cls = "bg-slate-950 border-slate-700 text-white";
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} title="Cambia password" className="w-11 h-11 -m-3 flex items-center justify-center text-slate-400 hover:text-white touch-manipulation" data-testid="driver-change-password-btn">
        <KeyRound size={18}/>
      </button>
      <Dialog open={open} onOpenChange={(o) => !o && close()}>
        <DialogContent className="bg-[#0C121E] border-slate-800 text-white max-w-sm" data-testid="change-password-dialog">
          <DialogTitle className="font-display flex items-center gap-2"><KeyRound size={18} className="text-amber-400"/>Cambia password</DialogTitle>
          <form onSubmit={submit} className="space-y-3">
            <Input type="password" autoComplete="current-password" placeholder="Password attuale" value={f.current} onChange={set("current")} className={cls} required data-testid="cp-current"/>
            <Input type="password" autoComplete="new-password" placeholder="Nuova password" value={f.next} onChange={set("next")} className={cls} required data-testid="cp-new"/>
            <Input type="password" autoComplete="new-password" placeholder="Conferma nuova password" value={f.confirm} onChange={set("confirm")} className={cls} required data-testid="cp-confirm"/>
            <div className="text-[11px] text-slate-500">Almeno 8 caratteri, con lettere e numeri.</div>
            {err && <div className="text-sm text-rose-400" data-testid="cp-error">{err}</div>}
            <button type="submit" disabled={busy} className="w-full py-2.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold disabled:opacity-50" data-testid="cp-submit">{busy ? "Salvataggio…" : "Aggiorna password"}</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChangePasswordButton;
